import Paper from '@material-ui/core/Paper';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import deepmerge from 'deepmerge';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { SegmentResponse } from '../../models/itinerary';
import { AppState } from '../../store/model';
import { getSegmentType, isSaviSelectIntl } from '../../store/reducers/itinerary/selectors';
import { breakpointMobile } from '../lab/breakpoints';
import { spacings } from '../lab/spacings';
import { Content } from './Content/Content';
import { getSegmentTypeForSaviSelectIntl } from '../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  segmentId: SegmentResponse['orderId'];
}

interface StateProps {
  segmentType: SegmentResponse['segmentType'];
}

interface SegmentDesktopProps
  extends OwnProps,
    StateProps,
    WithStyles<typeof styles> {}

class SegmentDesktopBase extends PureComponent<SegmentDesktopProps> {
  public render() {
    const { classes, segmentId, segmentType } = this.props;
    return (
      <Paper
        className={classNames(
          classes.content,
          classes[`type${segmentType}` as SegmentTypeClassKey],
        )}
      >
        <Content segmentId={segmentId} />
      </Paper>
    );
  }
}

// styled
type SegmentTypeClassKey = 'typeAir' | 'typeCar' | 'typeHotel';

const styles = (theme: Theme) => {
  const {
    between: {
      card: { card: cardSpacing },
    },
  } = spacings(theme);

  const mobile = breakpointMobile(theme);

  const {
    zeno: {
      travelModes: { air, vehicle, accommodation },
    },
  } = theme;

  return createStyles({
    container: deepmerge(cardSpacing, {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      width: 'auto',
      height: 'auto',
      zIndex: 1,
      '&:first-of-type': {
        marginTop: 0,
      },
    }) as any,
    content: {
      flex: 'auto',
      flexDirection: 'row',
      overflow: 'hidden',
      overflowY: 'hidden',
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      [mobile]: {
        overflowY: 'scroll',
      },
    },
    typeAir: {
      backgroundColor: air.lightest,
    },
    typeCar: {
      backgroundColor: vehicle.lightest,
    },
    typeHotel: {
      backgroundColor: accommodation.lightest,
    },
  });
};

const mapStateToProps = (state: AppState, { segmentId }: OwnProps) => {
  return {
    segmentType: !isSaviSelectIntl(state) ? getSegmentType(String(segmentId))(state) : getSegmentTypeForSaviSelectIntl(segmentId)(state),
  };
};

const enhance = compose<SegmentDesktopProps, OwnProps>(
  connect(
    mapStateToProps,
  ),
  withStyles(styles),
);

/**
 * Segment (for desktop screens)
 */
export const SegmentDesktop = enhance(SegmentDesktopBase);

SegmentDesktop.displayName = 'SegmentDesktop';
